import router from "@/router.js"

function redPage(page, params) {
    router.replace({ name: page, params: params })
}

export default redPage;